import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import type {
  TPostCompanyUBODocumentFromPersonaParams,
  TPostCompanyUBODocumentFromPersonaResponse,
} from "./postCompanyUBODocumentFromPersona.schema";

export const postCompanyUBODocumentFromPersona = (axios: IAxiosInstance) => {
  return async (
    params: TPostCompanyUBODocumentFromPersonaParams
  ): Promise<TPostCompanyUBODocumentFromPersonaResponse> => {
    const { companyID, persona_inquiry_id, first_name, last_name } = params;
    const response = await axios.noRetry.post<
      IApiResponse<TPostCompanyUBODocumentFromPersonaResponse>
    >(`/api/companies/${companyID}/ubo-document-from-persona`, {
      persona_inquiry_id,
      first_name,
      last_name,
    });
    const resData = response.data;
    if (resData?.data?.success) {
      return {
        success: true,
        message: resData.data?.message ?? "",
      };
    }
    throw new Error("Something went wrong");
  };
};
